import React from "react";
import { Auth0ContextInterface, useAuth0 } from "@auth0/auth0-react";

import styles from "./Landing.module.css";
import Header from "../layout/header/Header";

const Landing: React.FC = () => {
  const { isAuthenticated }: Auth0ContextInterface = useAuth0();

  return (
    <>
      <Header pageTitle="Welcome!" />
      <div className={styles.landing}>
        <h1>Welcome to the Tasktop Customer Portal!</h1>
        {isAuthenticated ? (
          <p>Please use the sidebar on the left to navigate the site.</p>
        ) : (
          <p>Please Login or Sign-Up at the top right of the page.</p>
        )}
        <section className={styles.productNews}>
          <div className={styles.newsContainer}>
            <div className={styles.newsContent}>
              <article className={styles.newsItem}>
                <h3>Important Product Note</h3>
                <p className={styles.newsDate}>August 12, 2026</p>
                <p>
                  Planview Hub 26.1.2 (February 2026 GA release) introduced a
                  refreshed user interface for Activity pages and Collections
                  configuration. The purposes of the UI changes are to align the
                  look and feel of Hub with that of other Planview products,
                  providing a more seamless and streamlined experience across
                  Planview products, and to replace the older AngularJS
                  framework on which its UI was previously built with an
                  up-to-date React framework, providing improved security and
                  supportability going forward. Updated Hub product
                  documentation is available.
                </p>
              </article>
            </div>
            <div className={styles.newsImage}>
              <img
                src="/product_news_activity_ui.png"
                alt="Product Update Activity UI Changes"
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Landing;
